export default __webpack_public_path__ + "static/media/14.e773e024.svg";